// extracted by mini-css-extract-plugin
export default {"student-discount":"SubscriptionStatus--student-discount--Ad2ZS","studentDiscount":"SubscriptionStatus--student-discount--Ad2ZS","icon":"SubscriptionStatus--icon--Vgr-J"};